<div class="form-control mb-3 pointer" *ngIf="isOperationExpanded" [class.form-control-active]="isSelected" (click)="onExpandOperation()">
    <div class="d-flex align-items-center">
        <b>{{ operation.name }} ({{ operation.machineName }})</b>
        <i class="pointer ms-15" [ngClass]="isCollapsed ? 'fa fa-angle-up' :'fa fa-angle-down'"></i>
    </div>
    
    <div class="mt-1" [ngClass]="isCollapsed ? 'd-block' : 'd-none'">
        <p *ngIf="operation.comment"><b>Komentar:</b> {{ operation.comment }}</p>
        <div class="d-flex justify-content-between">
            <div>
                <app-tag class="me-2" [sector]="operation.sector" [isActive]="true"></app-tag>
    
                <div class="tag me-2">
                    {{ operation.quantity | digitFormat }}
                    <span class="tag-addon"><i class="fa fa-layer-group"></i></span>
                </div>
                <div class="tag me-2">
                    <span>{{ operation.timeEstimatedEmployeePermanent | digitFormat }}min</span> <span *ngIf="operation.workersCountPermanent > 1" class="ms-1">x{{ operation.workersCountPermanent }}</span>
                    <span class="tag-addon"><i class="fa fa-user"></i></span>
                </div>
                <div class="tag me-2">
                    {{ operation.timeEstimatedMachine | digitFormat }}min
                    <span class="tag-addon"><i class="fa fa-cog"></i></span>
                </div>
                <div class="tag me-2">
                    <span>{{ operation.timeEstimatedEmployeeSeasonal | digitFormat }}min</span> <span *ngIf="operation.workersCountSeasonal > 1" class="ms-1">x{{ operation.workersCountSeasonal }}</span>
                    <span class="tag-addon"><i class="fa fa-user-clock"></i></span>
                </div>
                <div *ngIf="operation.estimatedCountSesonalWorkersDaily" class="tag me-2">
                    <span>{{ operation.estimatedCountSesonalWorkersDaily | digitFormat }}</span>
                    <span class="tag-addon"><i class="fa fa-users"></i></span>
                </div>
            </div>
            <div class="d-flex align-items-center" *ngIf="userSectors.includes(operation.sector)">
                <app-delete class="ms-auto" *ngIf="permissionHelper.isEnabledMethod('deleteOperationForWorkRequest')" (selected)="onDeleteOperation(operation.id)" ngxClickStopPropagation></app-delete>
                <i class="fa fa-edit pointer ms-3" *ngIf="permissionHelper.isEnabledMethod('editWorkRequestOperation')" (click)="onSelectOperation(operation)" ngxClickStopPropagation></i>
            </div>
        </div>
    </div>
</div>

<div class="form-control mb-3" *ngIf="!isOperationExpanded" [class.form-control-active]="isSelected">
    <div class="d-flex align-items-center">
        <app-tag *ngIf="operation.isExternalOperation" class="me-2" [sector]="operation.sector" [isActive]="true"></app-tag>
        <b>{{ operation.name }} ({{ !operation.isExternalOperation ? operation.machineName : operation.operationSupplier }}) <i *ngIf="operation.isPriority" class="fa fa-flag text-red ms-2" tooltipStr="Prioritet"></i></b>
        <i *ngIf="operation.isExternalOperation" class="fa fa-arrow-up-right-from-square ms-10" tooltipStr="Eksterna operacija"></i>
        <i *ngIf="operation.isAdded" class="fa-solid fa-plus ms-10" tooltipStr="Naknadno dodato"></i>
    </div>
    <div class="font-14" *ngIf="operation.productName">Artikal: {{ operation.productName }}</div>
    
    <div>
        <div class="mb-5" *ngIf="operation.comment"><b>Komentar:</b> {{ operation.comment }}</div>
        <div class="d-flex justify-content-between">
            <div>
                <div *ngIf="!operation.isExternalOperation">
                    <app-tag class="me-2" [sector]="operation.sector" [isActive]="true"></app-tag>
        
                    <div class="tag me-2">
                        {{ operation.quantity + operation.quantityCorrection | digitFormat }}
                        <span class="tag-addon"><i class="fa fa-layer-group"></i></span>
                    </div>
                    <div class="tag me-2">
                        {{ operation.timeEstimatedMachine + operation.timeCorrectionMachine | digitFormat }}min
                        <span class="tag-addon"><i class="fa fa-cog"></i></span>
                    </div>
                    <div class="tag me-2">
                        <span>{{ operation.timeEstimatedEmployee + operation.timeCorrectionEmployee | digitFormat }}min</span> <span *ngIf="operation.workersCount > 1" class="ms-1">x{{ operation.workersCount }}</span>
                        <span class="tag-addon"><i class="fa fa-user"></i></span>
                    </div>
                </div>
            </div>
            <div class="d-flex align-items-center" *ngIf="userSectors.includes(operation.sector)">
                <app-delete class="ms-auto" *ngIf="permissionHelper.isEnabledMethod('deleteOperationForWorkOrder')" (selected)="onDeleteOperation(operation.id)"></app-delete>
                <i class="fa fa-edit pointer ms-3" *ngIf="permissionHelper.isEnabledMethod('editWorkOrderOperation') && !operation.isExternalOperation" (click)="onSelectOperation(operation)"></i>
            </div>
        </div>
    </div>
</div>
